import { useTranslation } from 'react-i18next';

export default function CtaSection() {
  const { t } = useTranslation();

  return (
    <section className="relative h-screen w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20inviting%20minimal%20lifestyle%20flatlay%20with%20fashion%20accessories%20shopping%20bags%20tissue%20paper%20on%20light%20cream%20textured%20surface%20soft%20natural%20daylight%20clean%20scandinavian%20aesthetic%20editorial%20product%20photography%20neutral%20warm%20tones%20peaceful%20artistic%20composition&width=1600&height=900&seq=cta-bg-v2&orientation=landscape"
        alt="Oopbuy Spreadsheet Shopping"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />

      <div className="relative z-10 h-full flex flex-col justify-between px-4 md:px-8 lg:px-20 py-24">
        {/* Top-left: main title */}
        <div className="mt-12 md:mt-16">
          <h2 className="text-[56px] md:text-[72px] font-heading font-extrabold text-white leading-[0.95] lowercase">
            {t('cta.title')}
          </h2>
        </div>

        {/* Bottom area: description + button */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8">
          <div>
            <p className="text-white/80 text-lg md:text-xl font-light leading-relaxed max-w-md">
              {t('cta.desc1')}
            </p>
            <p className="text-white/60 text-sm mt-2">
              {t('cta.desc2')}
            </p>
          </div>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-3 h-14 w-[200px] rounded-full bg-white text-foreground-900 text-base font-semibold hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            {t('cta.button')}
            <span className="w-9 h-9 rounded-full bg-foreground-950 flex items-center justify-center">
              <i className="ri-arrow-right-line text-white text-sm"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}